import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import DynamicForm from '../../../../customformComponent/customForm/DynamicForm';
import backicon from "../../../../../Assets/icons/backIcon.svg"

const CustomerInputs = [
  {
    name: "po_no.",
    label: "PO NO.",
    type: "number",
    required: true,
    gridClass: "col-lg-4",
  },
  {
    name: "PO Date",
    label: "po_date",
    type: "text",
    required: true,
    gridClass: "col-lg-4",
  },
  {
    name: "order_type",
    label: "Order Type",
    type: "number",
    required: true,
    gridClass: "col-lg-4",
  },
  {
    name: "vendor_name",
    label: "Vendor Name",
    type: "text",
    required: true,
    gridClass: "col-lg-4",
  },
  { 
    name: "vendor_type",
    label: "Vendor Type",
    type: "text",
    required: true,
    gridClass: "col-lg-4",
  },
  {
    name: "oem_branch",
    label: "Oem Branch ",
    type: "text",
    required: true,
    gridClass: "col-lg-4",
  },
  {
    name: "product_name",
    label: "Product Name",
    type: "text",
    required: true,
    gridClass: "col-lg-4",
  },
  {
    name: "sub_product_details",
    label: "Sub Product Details",
    type: "text",
    required: true,
    gridClass: "col-lg-4",
  },
  {
    name: "make",
    label: "Make",
    type: "text",
    required: true,
    gridClass: "col-lg-4",
  },
  {
    name: "model",
    label: "Model",
    type: "text",
    required: true,
    gridClass: "col-lg-4",
  },
  {
    name: "variant",
    label: "Variant",
    type: "text",
    required: true,
    gridClass: "col-lg-4",
  },
  {
      name: "fuel_type",
      label: "Fuel Type",
      type: "multiselectdropdown",
      required: true,
      options: [
        { label: "DIESEL", value: "DIESEL" },
        { label: "PETROL", value: "PETROL" },
      ],
      gridClass: "col-lg-4",
    },
  {
    name: "color",
    label: "Color",
    type: "text",
    required: true,
    gridClass: "col-lg-4",
  },
  {
    name: "no_of_quantity",
    label: "No. Of Quantity",
    type: "number",
    required: true,
    gridClass: "col-lg-4",
  },
  {
    name: "vendor_name",
    label: "Vendor Name",
    type: "text",
    required: true,
    gridClass: "col-lg-4",
  },
  {
    name: "department",
    label: "Department",
    type: "text",
    required: true,
    gridClass: "col-lg-4",
  },
  {
    name: "payment_type",
    label: "Payment Type",
    type: "text",
    required: true,
    gridClass: "col-lg-4",
  },
  {
    name: "po_expected_date",
    label: "Department",
    type: "text",
    required: true,
    gridClass: "col-lg-4",
  },
  {
    name: "payment_date",
    label: "Payment Date",
    type: "text",
    required: true,
    gridClass: "col-lg-4",
  },
  {
    name: "showroom_center",
    label: "Showroom Center",
    type: "text",
    required: true,
    gridClass: "col-lg-4",
  },
];



const AddPoApproval = () => {

  const [formData, setFormData] = useState({});


  // Add states for table data 
  const [tableData, setTableData] = useState([]); 

  const navigate = useNavigate();

  const handleFormSubmit = (data) => {
    // Convert multiselectdropdown data to a readable format
    const processedData = {
      ...data,
      fuel_type: data.fuel_type.map(item => item.label).join(', ')
    };
    setTableData(prevData => [...prevData, processedData]);
    console.log("Form Data:", processedData);
    setFormData({})
  };

  return (
    <div>
      <div style={{display:"flex", justifyContent:"space-between", alignItems:"center"}}>
            <div className="backbutton mt-2 mb-2">
        <img src={backicon} alt="back" onClick={() => navigate(-1)}/>
        <span className="backbtntitle">New Purchase Order</span>
      </div>


      <div className="btncontainer mt-3 gap-2">
        <button style={{backgroundColor:"#fff", padding:"10px 20px" , borderRadius:"10px", color:"#7BD755", border:"1px solid #7BD755"}}>
            Back
        </button>
        <button
        onClick={() => handleFormSubmit(formData)}
          className="submit-btn"
        >
          Submit
        </button>
      </div>

      </div>
      <div className="form-container">
        {/* <div className="d-flex flex-row justify-content-between" style={{marginBottom:"25px"}}>
            <div>
        <span className="cust-det-title mt-2 mb-2">
          Add
        </span>
            </div>
        </div> */}
        <p style={{fontSize:"20px", color:"grey"}}>Personal Details </p>
        <DynamicForm
        formConfig={CustomerInputs}
        formData={formData}
        setFormData={setFormData}
        onSubmit={handleFormSubmit}
          // formConfig={CustomerInputs}
          // formData={formData}
          // setFormData={setFormData}
          // onSubmit={handleFormSubmit}
        />
        {/* <div>
        <p style={{fontSize:"20px", color:"grey"}}>Vehicle Details </p>
        <DynamicForm
        formConfig={VehicleInputs}
        formData={formData}
        setFormData={setFormData}
        onSubmit={handleFormSubmit}
          // formConfig={CustomerInputs}
          // formData={formData}
          // setFormData={setFormData}
          // onSubmit={handleFormSubmit}
        />
        </div> */}

      </div>
    </div>
  )
}

export default AddPoApproval;